import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BUSINESS } from "@/data/content";

export default function CTA() {
  const scrollTo = () => {
    const el = document.querySelector("#contact");
    if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
    else if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="cta-section" className="relative h-[70vh] min-h-[520px] overflow-hidden flex items-center">
      <img
        src="/images/cta.webp"
        alt="Modern luxury home glowing at night with warm architectural lighting"
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-ink/70" />
      <div className="relative max-w-[1600px] mx-auto px-6 lg:px-24 w-full">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <p className="font-mono text-[10px] tracking-[0.35em] text-goldw uppercase mb-6">Free Consultation</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-ivory leading-[1.08]" data-testid="cta-headline">
            Your Home Deserves<br /><span className="italic text-goldw">a Higher Standard.</span>
          </h2>
          <div className="mt-10 flex flex-wrap gap-4">
            <button
              data-testid="cta-quote-btn"
              onClick={scrollTo}
              className="inline-flex items-center gap-2 bg-goldw text-ink font-mono text-[11px] tracking-[0.22em] uppercase px-8 py-4 hover:bg-ivory transition-colors duration-300"
            >
              Book a Free Consultation <ArrowUpRight size={14} />
            </button>
            <a
              href={BUSINESS.phoneHref}
              data-testid="cta-phone-link"
              className="inline-flex items-center border border-ivory/40 text-ivory font-mono text-[11px] tracking-[0.22em] uppercase px-8 py-4 hover:border-goldw hover:text-goldw transition-colors duration-300"
            >
              {BUSINESS.phone}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
